<div class="modal fade in clsModal" tabindex="-1" style="background:rgba(0,0,0, 0.5);" (onHide)="onHide()">
  <div class="modal-dialog clsModalDialog">
      <div class="modal-content clsModalContent">

          <div class="modal-header clsModalHeader">
              <h4 *ngIf="!isSessionExpired"  class="modal-title ui mb16 font_semibold font_size_20 clsModalTitle">Sign out</h4>
              <h4 *ngIf="isSessionExpired"  class="modal-title ui mb16 font_semibold font_size_20 clsModalTitle">Session timeout</h4>
              <span class="close icon icon-cross-special" (click)="onHide()"><img
                  *ngIf="!isSessionExpired"    src="assets/images/icon-close-popup@2x.png" /></span>
              <div class="row">
                  <div class="col-xs-12">
                  </div>
              </div>
          </div>

          <div  *ngIf="!isSessionExpired" class="modal-body clsModalBody">
                  Are you sure you want to exit?
          </div>
          <div  *ngIf="isSessionExpired" class="modal-body clsModalBody">
            Your session has been expired, please relogin.
          </div>

          <div class="modal-footer">
              <button  *ngIf="!isSessionExpired" class="btn font_size_13 btn_gray clsCancel" (click)="onHide()">No</button>
              <button *ngIf="!isSessionExpired" class="btn font_size_13 btn_blue clsCreate"
                  (click)="ConfirmDelete()">Yes</button>
                  <button *ngIf="isSessionExpired" class="btn font_size_13 btn_blue clsCreate"
                  (click)="ConfirmDelete()">OK</button>
          </div>

      </div>
  </div>
</div>